module.exports = __webpack_public_path__ + "img/@work_bottom.941ab79c.jpg";